import React, {useContext} from 'react'
import {useStyles} from "./AssociationLogo.css";
import {CircleRounded} from "@mui/icons-material";
import associationStructure from "../../associationStructure/associationStructure.json";
import {FirebaseAuthContext} from "../../firebase/FirebaseAuthProvider";

const AssociationLogo = ({association, height, width}) => {
    const classes = useStyles({height: height, width: width})
    const {signedInUserRoleScopes, signedInUserRole} = useContext(FirebaseAuthContext);

    // IMPORTANT: The logo is not restricted based on the allowed association (this actually only affects the "user" entities, which are shared among associations)
    const logoFilename = associationStructure[association]?.logo

    if (logoFilename) {
        // As the player role can choose his/her scopes in the profile section, the logo must never be shown in the transparent-mode
        return <img src={require(`../../../../assets/${logoFilename}`)}
                    className={signedInUserRoleScopes?.includes(association) || signedInUserRole === 'player' ? classes.picture : classes.pictureTransparent}
                    alt={`${association} logo`}/>
    }

    return <CircleRounded className={classes.picture}/>
}
export default AssociationLogo
